import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/devis/components/QuoteRequestForm.tsx");
